import { render, staticRenderFns } from "./PropertyPhotos.vue?vue&type=template&id=6f2a4a40&scoped=true&"
import script from "./PropertyPhotos.vue?vue&type=script&lang=js&"
export * from "./PropertyPhotos.vue?vue&type=script&lang=js&"
import style0 from "./PropertyPhotos.vue?vue&type=style&index=0&id=6f2a4a40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2a4a40",
  null
  
)

export default component.exports